<mat-toolbar class="sticky top-0 grid grid-flow-col w-full gap-4 px-6 auto-cols-max justify-between">
    <div class="grid grid-flow-col gap-4">
        <div class="self-center">
            <a class="brand" routerLink="/home" aria-label="Momentum Wellness home">
                <img class="h-[32px]" src="assets/brand/mom-perigon-logo-simplified.svg" alt="Momentum Health" />
            </a>
        </div>
        @if (verifyPermissions.isAuthenticated()) {
            <div class="hidden xl:grid grid-flow-col gap-4">
                @for (item of items; track $index) {
                    @if (item.validPermission) {
                        @if (item.children && item.children.length > 0) {
                            <button matButton="text" type="button" [matMenuTriggerFor]="subMenu" class="mom-danger">
                            <mat-icon>{{ item.icon }}</mat-icon>
                                {{ item.title }}
                        </button>
                                        <mat-menu #subMenu="matMenu">
                                            <nav-menu-items
                                                [items]="item.children"
                                                (navigate)="navigateTo($event)" />
                                        </mat-menu>
                        } @else {
                            <button matButton="text" type="button" (click)="navigateTo(item.route!)" class="mom-danger">
                            <mat-icon>{{ item.icon }}</mat-icon>
                                {{ item.title }}
                        </button>
                        }
                    }
                }
            </div>
        }
    </div>
    <div class="grid grid-flow-col gap-4">
        <div>
            @if (verifyPermissions.canAccessHangfire()) {
                <button matButton="filled" type="button" (click)="goToHangfire()">
                    <mat-icon>ssid_chart</mat-icon>
                    Hangfire
                </button>
            }
        </div>
        <div>
            @if (verifyPermissions.isAuthenticated()) {
                <button matButton="filled" type="button" class="mom-danger" (click)="logout()">
                    <mat-icon>logout</mat-icon>
                    Sign out
                </button>
            } @else {
                <button matButton="filled" type="button" (click)="login()">
                    <mat-icon>login</mat-icon>
                    Sign in
                </button>
            }
        </div>
    </div>
</mat-toolbar>
